import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import * as Sentry from '@sentry/angular';

import { AppModule } from './app/app.module';
import { tagConnectionErrors } from './app/utils/connection-error';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

const { sentry } = environment;

if (sentry) {
  Sentry.init({
    dsn: sentry.dsn,
    environment: sentry.environment,
    release: sentry.release,
    integrations: [
      Sentry.browserTracingIntegration(),
    ],
    tracePropagationTargets: sentry.tracePropagationTargets,
    tracesSampleRate: sentry.tracesSampleRate,
    beforeSend: tagConnectionErrors,
  });
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
